export default __webpack_public_path__ + "static/media/practiceExam.dced8076.svg";